import { extractNumber } from '@cred/shared/utils'

export const minMaxBalanceAmount = (value) => {
  const numberValue = extractNumber(value)
  let error

  if (numberValue < 1 || numberValue > 999999) {
    error = 'Please enter an amount between $1 and $999,999'
  }

  return error
}
